import { WorkList } from './WorkList.js';
import { PatientDobChangeWarningMixin } from '../Mixins/PatientDobChangeWarningMixin.js';

export class SubmitCase extends PatientDobChangeWarningMixin(HTMLElement) {
    static initiated = false;

    constructor() {
        super();
        const url = window.location.href;
        if (url.indexOf("id=") > -1 || url.indexOf("feedback") > -1) {
            this.worklist = new WorkList();
        }
    }

    connectedCallback() {
        super.connectedCallback();
        if (this.worklist) {
            this.worklist.connectedCallback();
        }
        this.init();
        SubmitCase.initiated = true;
    }

    disconnectedCallback() {
        window.removeEventListener('popstate', this._boundOnPopState);
    }

    init() {
        const _self = this;

        const genderSelectorElem = document.querySelector("select[name=gender]");
        const unknownOption = genderSelectorElem.querySelector('option[value="4"]');
        unknownOption.disabled = true;
        if (genderSelectorElem.value === "4") {
            genderSelectorElem.setCustomValidity("Undefined is not a valid option");
        }

        const speciesElem = document.querySelector("input[name=Species]");
        speciesElem.required = true;
        speciesElem.setAttribute("pattern", "(?!(o|O)(t|T)(h|H)(e|E)(r|R))[a-z\\-A-Z0-9, ]+");

        const breedElement = document.querySelector("input[name=Breed]");
        breedElement.required = true;
        breedElement.setAttribute("pattern", "(?!(o|O)(t|T)(h|H)(e|E)(r|R))[a-z\\-A-Z0-9, ]+");

        this.checkForResubmit();

        // delay to allow DOM updates
        _self.initEventHandlers();
    }

    resubGroup(resubGroupID) {
        // now need to set the consultant group.
        const consultantGroupSelector = document.querySelector(".c_d_r_map_consultant_group");
        const currentOption = consultantGroupSelector.querySelector("option[selected");
        if (consultantGroupSelector.value != resubGroupID) {
            const resubGroupOption = consultantGroupSelector.querySelector('option[value="' + resubGroupID + '"]');
            if (resubGroupOption) {
                if (currentOption) {
                    currentOption.removeAttribute("selected");
                }
                resubGroupOption.setAttribute("selected", "selected");
                consultantGroupSelector.value = resubGroupID;
                $(consultantGroupSelector).trigger("change");
            }
        }
    }

    resubPriority(resubPriorityID) {
        const prioritySelector = document.querySelector("select.priorityTypes");
        const currentOption = prioritySelector.querySelector("option[selected]");
        if (prioritySelector.value != resubPriorityID) {
            const resubPriorityOption = prioritySelector.querySelector('option[value="' + resubPriorityID + '"]');
            if (resubPriorityOption) {
                if (currentOption) {
                    currentOption.removeAttribute("selected");
                }
                resubPriorityOption.setAttribute("selected", "selected");
                prioritySelector.value = resubPriorityID;
                $(prioritySelector).trigger("change");
            }
        }
    }

    checkForResubmit() {
        const resubmitInput = this.querySelector("input[name=reSubmit]");
        if (resubmitInput.value == 0) {
            return;
        }

        const resubClinicInput = this.querySelector("input[name=prev_clinic_id]");
        let resubClinicID = resubClinicInput.value;

        const resubGroupInput = this.querySelector("input[name=prev_rad_group_id]");
        const resubGroupID = resubGroupInput.value;

        const resubPriorityInput = this.querySelector("input[name=prev_priority]");
        const resubPriorityID = resubPriorityInput.value;

        // check if selected Clinic is the clinic from prev_submission
        const clinicSelector = document.querySelector(".c_d_r_map_clinic");
        if (clinicSelector.value != resubClinicID) {
            const currentOption = clinicSelector.querySelector("option[selected]");
            if (currentOption && currentOption.value != resubClinicID) {
                const resubClinicOption = clinicSelector.querySelector('option[value="' + resubClinicID + '"]');
                if (resubClinicOption) {
                    if (currentOption) {
                        currentOption.removeAttribute("selected");
                    }
                    resubClinicOption.setAttribute("selected", "selected");
                    clinicSelector.value = resubClinicID;
                    setTimeout(() => {
                        $(clinicSelector).trigger("change");
                    }, 100);
                }
            }
        }

        if (resubGroupID > 0) {
            setTimeout(() => this.resubGroup(resubGroupID), 100);
        }

        if (resubPriorityID > 0) {
            setTimeout(() => this.resubPriority(resubPriorityID), 100);
        }
    }

    initEventHandlers() {
        const _self = this;

        _self.onGenderChange = _self.onGenderChange.bind(_self);
        const genderSelectorElem = document.querySelector("select[name=gender]");
        genderSelectorElem.addEventListener("change", _self.onGenderChange);

        this.onReturnToUrl = this.onReturnToUrl.bind(this);
        document.addEventListener("return-url-event", this.onReturnToUrl);

        const newCdrMapBtn = this.querySelector(".c_d_r_map_doctors_new");
        newCdrMapBtn.addEventListener("click", this.renderNewDoctorForm.bind(this));

        $(".c_d_r_map_clinic").on("change", this.renderMapClinic.bind(this));
        $(".c_d_r_map_consultant_group").on("change", this.renderMapConsultantGroup.bind(this));

        if (!SubmitCase.initiated) {
            $("body").on("click", ".clinic_new_doctor", (event) => {
                this.appendNewDoctor(event);
            });

            $("body").on("submit", ".doctor_append form", (event) => {
                event.preventDefault();
            });
        }

        this._boundOnPopState = this.onPopState.bind(this);
        window.addEventListener('popstate', this._boundOnPopState);
    }

    onGenderChange(event) {
        event.stopPropagation();

        if (event.target.value === "4") {
            event.target.setCustomValidity("Undefined is not a valid option");
        } else {
            event.target.setCustomValidity("");
        }
    }

    onReturnToUrl(event) {
        console.log("%c event", "color:orange");
        if (event.detail.originalEvent) {
            const returnUrl = event.detail.returnUrl || false;
            if (returnUrl) {
                let message = "Successfully saved case submission.  ";
                if (event.detail.originalEvent.classList.contains("submit-for-review")) {
                    message = "Successfully submitted case for review.  ";
                }
                toastr.success(message + "Redirecting you back to your referring page", "Success", {
                    onHidden: () => {
                        const searchParams = new URLSearchParams({
                            success: true,
                            message: message,
                        });
                        document.location.href = returnUrl + "?" + searchParams.toString();
                    },
                });
            }
        }
    }

    appendNewDoctor(event) {
        var url = "/doctors?a=2&spid=0";
        var data = $(".doctor_append").find("form").serialize();
        $(".loader").removeClass("hide");
        $.ajax({
            type: "POST",
            url: url,
            dataType: "JSON",
            data: data,
            success: function (data) {
                $(".loader").addClass("hide");
                if (data.saved) {
                    var val = window.c_d_r_map;
                    window.c_d_r_map[data.ClinicID].doctors.push({
                        ClinicID: data.ClinicID,
                        LastName: $(".doctor_append").find('[name="LastName"]').val(),
                        FirstName: $(".doctor_append").find('[name="FirstName"]').val(),
                        ClinicDoctorID: data.id,
                    });
                    $(".c_d_r_map_clinic").val(data.ClinicID).trigger("change");
                    $(".c_d_r_map_doctors").val(data.id).trigger("change");
                    $(".doctor_append").modal("hide");
                    $("body").removeClass("modal-open");
                    $(".modal-backdrop").remove();
                } else {
                    $.each(data.errors, function (i, error) {
                        $(".doctor_append")
                            .find('[name="' + i + '"]')
                            .addClass("has-error")
                            .closest(".form-group")
                            .addClass("has-error")
                            .find(".help-block")
                            .html(error);
                    });
                }
            },
        });
    }

    renderNewDoctorForm(event) {
        event.preventDefault();
        var o = this;
        // check if form is still on the page
        if ($(".doctor_append").length > 0) {
            $(".doctor_append").remove();
        }

        var html = '<div class="doctor_append modal fade">';
        var clinics = $(".c_d_r_map_clinic").html();
        var clinicSelected = $(".c_d_r_map_clinic").val();
        $.get(
            "/assets/html/doctor.html?time=" +
                (window.performance &&
                window.performance.now &&
                window.performance.timing &&
                window.performance.timing.navigationStart
                    ? window.performance.now() + window.performance.timing.navigationStart
                    : Date.now()),
            function (data) {
                html += data;
                html += "</div>";
                $("body").append(html);
                $(".doctor_append").modal({ show: true });
                $(".doctor_append").find('[name="ClinicID"]').html(clinics).val(clinicSelected);

                const cancelDoctorBtn = document.querySelector(".clinic_cancel_new_doctor");
                cancelDoctorBtn.addEventListener("click", (event) => {
                    event.preventDefault();
                    setTimeout(function () {
                        const doctorDialog = document.querySelector(".doctor_append");
                        if (doctorDialog) {
                            $(doctorDialog).remove();
                        }

                        const newDoctorBtn = document.querySelector(".clinic_new_doctor");
                        newDoctorBtn.addEventListener("click", this.appendNewDoctor.bind(this));
                    }, 1000);
                });


            }
        );
    }

    renderMapClinic(event) {
        event.preventDefault();
        const el = event.target;
        var o = this;
        var val = window.c_d_r_map[el.value];
        if (typeof val != "undefined") {
            var content = '<option value="" disabled="disabled" selected="selected"></option>';
            $.each(val.doctors, function (i, doc) {
                content +=
                    '<option value="' + doc.ClinicDoctorID + '">' + doc.LastName + " " + doc.FirstName + "</option>";
            });
            $(".c_d_r_map_doctors")
                .html(content)
                .data("placeholder", "Select a doctor")
                .select2({ placeholder: "Select a doctor", val: "" });
            const cdr_map_doctors = document.querySelector(".c_d_r_map_doctors");
            cdr_map_doctors.dataset.placeholder = "Select a doctor";

            content = '<option value="" disabled="disabled" selected="selected"></option>';
            $(".c_d_r_map_radiologist").html(content).data("placeholder", "First select a group").select2({
                placeholder: "First select a group",
                val: "",
            });
            $(".c_d_r_map_review_type").html(content).data("placeholder", "First select a group").select2({
                placeholder: "First select a group",
                val: "",
            });
            $.each(val.radGoups, function (i, group) {
                content += '<option value="' + group.RadGroupID + '">' + group.RadGroupName + "</option>";
            });
            $(".c_d_r_map_consultant_group")
                .html(content)
                .data("placeholder", "Select a group")
                .data("clinic", val.id)
                .select2({
                    placeholder: "Select a group",
                    val: "",
                });
            const cdr_map_consultant_group = document.querySelector(".c_d_r_map_consultant_group");
            cdr_map_consultant_group.dataset.placeholder = "Select a group";
            cdr_map_consultant_group.dataset.clinic = val.id;
        }
    }

    renderMapConsultantGroup(event) {
        event.preventDefault();
        const el = event.target;
        var o = this;
        var val = window.c_d_r_map[el.dataset.clinic];
        if (typeof val != "undefined") {
            var group = el.value;
            $.each(val.radGoups, function (i, g) {
                if (group == g.RadGroupID) {
                    o.renderMapConsultantGroupCreateMap(g, group, val);
                }
            });
        }
    }

    renderMapConsultantGroupCreateMap(g, group, val)
    {
        if (g.stat == 1 || group == 149) {
            $(".priorityTypes")
                .html(
                    (group != 149 ? '<option value="0">Normal</option>' : "") +
                        '<option value="1"' +
                        (group == 149 ? "selected" : "") +
                        ">STAT</option>"
                )
                .removeClass("disabled");
        } else {
            $(".priorityTypes").html('<option selected="selected" value="0">Normal</option>').addClass("disabled");
        }
        if (g.firstAvailableOnly != 1) {
            var content = '<option value="" disabled="disabled" selected="selected"></option>';
            content += '<option value="-2" class="first_available_option">First Available</option>';
            if (g.DoesNighthawk == 1) {
                content +=
                    '<option value="-1" class="nighthawk_option">After Hours/Nighthawk (Provided through Vetology)</option>';
            }
            $.each(g.members, function (a, m) {
                var cto =
                    parseFloat(m.detail.CaseTimeOut) > 0
                        ? "&nbsp;&nbsp;&nbsp;(Case TO: " + m.detail.CaseTimeOut + ")"
                        : "";
                content +=
                    '<option value="' +
                    m.RadiologistID +
                    '">' +
                    m.detail.FirstName +
                    " " +
                    m.detail.LastName +
                    ", " +
                    m.detail.Title +
                    cto +
                    "</option>";
            });
        } else {
            var content =
                '<option value="-2" selected="selected" class="first_available_option">First Available</option>';
        }
        $(".c_d_r_map_radiologist")
            .html(content)
            .data("placeholder", "Select a Consultant")
            .data("clinic", val.id)
            .data("group", g.RadGroupID)
            .select2({
                placeholder: "Select a Consultant",
                val: "",
            });
        const cdr_map_radiologist = document.querySelector(".c_d_r_map_radiologist");
            cdr_map_radiologist.dataset.placeholder = "Select a Consultant";
            cdr_map_radiologist.dataset.clinic = val.id;
            cdr_map_radiologist.dataset.group = g.RadGroupID;

        content = '<option value="" disabled="disabled" selected="selected"></option>';
        $.each(g.reviewTypes, function (a, t) {
            content += '<option value="' + t.RadGroupReviewTypeID + '">' + t.detail.ReviewTypeName + "</option>";
        });
        $(".c_d_r_map_review_type")
            .html(content)
            .data("placeholder", "Select the required service")
            .data("clinic", val.id)
            .data("group", g.RadGroupID)
            .select2({
                placeholder: "Select the required service",
                val: "",
            });
        const cdr_map_review_type  = document.querySelector(".c_d_r_map_review_type");
            cdr_map_review_type.dataset.placeholder = "Select the required service";
            cdr_map_review_type.dataset.clinic = val.id;
            cdr_map_review_type.dataset.group = g.RadGroupID;

        // allow notes read type only if group allows
        let $readTypeSelector = $("select[name=read_type]");
        let $notesOption = $("option[value=1]", $readTypeSelector);
        if ($notesOption.length && !parseInt(g.DoesNotes)) {
            $notesOption.remove();
        } else if ($notesOption.length == 0 && parseInt(g.DoesNotes)) {
            // need to add option back in
            $readTypeSelector.append($("<option value='1'>Notes</option>"));
        }

        // check if special rad group for ask aime question
        let radGroupID = $(".c_d_r_map_consultant_group").val();
        let $fullOption = $("option[value=0]", $readTypeSelector);
        if (radGroupID == 149 && $fullOption.length) {
            $fullOption.remove();
        } else if (radGroupID != 149 && $fullOption.length == 0) {
            // need to add full option back in
            $readTypeSelector.prepend($("<option value='0'>Full</option>"));
        }
    }

    onPopState(event) {
        event.stopImmediatePropagation();
        const backBtn = this.querySelector('.closeLevel');
        if (backBtn) {
            backBtn.click();
        }
    }
}

customElements.define('submit-case', SubmitCase);